<main>
    <div class="content">
        <div class="image-container">
            <img [src]="baseApiUrl + '/uploads/images/organization_chart/organization_chart_1.jpg'" alt="" class="main-image">
            <p class="image-text">{{ 'organization_chart.Organization Chart' | translate }}</p>
        </div>
        <div class="paragraph">
            <div class="row">
                <div class="col-lg-8 col-md-8 col-sm-8 col-12 paragraph-text sm-mb-0 mb-3">
                    <img *ngIf="currentLanguage === 'en'" [src]="baseApiUrl + '/uploads/images/organization_chart/organization_chart_2.png'" alt="">
                    <img *ngIf="currentLanguage === 'kh'" [src]="baseApiUrl + '/uploads/images/organization_chart/organization_chart_kh.jpg'" alt="">
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <app-side-menu></app-side-menu>
                </div>
            </div>
        </div>
    </div>
    <div class="bottom-content-poster" style="background-color: #EDEDED; margin-top: 20px;">
        <img [src]="baseApiUrl + '/uploads/images/customer_service/customer_service_1.jpg'" alt="">
        <a href="/download-app"><img [src]="baseApiUrl + '/uploads/images/mobile_download/mobile_download_1.jpg'" loading="lazy"></a>
    </div>
</main>